import React, { FC } from 'react';
import './Loader.css';

const Loader: FC = () => (
  <div className="loading">
    <ul role="progressbar" aria-busy="true" aria-label="Loading">
      <li role="presentation" />
      <li role="presentation" />
      <li role="presentation" />
      <li role="presentation" />
      <li role="presentation" />
      <li role="presentation" />
      <li role="presentation" />
    </ul>
  </div>
);

export default Loader;
